var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"my-4"},[_c('b-skeleton',{attrs:{"height":"250px","animated":true}})],1),_c('div',_vm._l((_vm.totalCard),function(item,index){return _c('div',{key:index,staticClass:"mb-4"},[_c('b-skeleton',{attrs:{"height":"50px","animated":true}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }